import { render, staticRenderFns } from "./wasteMaterials.vue?vue&type=template&id=40d1460d&scoped=true"
import script from "./wasteMaterials.vue?vue&type=script&lang=js"
export * from "./wasteMaterials.vue?vue&type=script&lang=js"
import style0 from "./wasteMaterials.vue?vue&type=style&index=0&id=40d1460d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d1460d",
  null
  
)

export default component.exports